import gql from 'graphql-tag'
import { IWorkplaceGroupEmployeesConnectionWithTotal } from '@api/types'
import { WorkplaceGroupEmployees } from '@api/fragments'
import client from '../../stores/apollo'

interface Payload {
  data: {
    node: IWorkplaceGroupEmployeesConnectionWithTotal
  }
}

export const workplaceGroupEmployeesQuery = gql`
  query WorkplaceGroupEmployees($id: ID!, $where: EmployeeWhereInput, $first: Int, $after: String) {
    node(id: $id) {
      ... on WorkplaceGroup {
        ...WorkplaceGroupEmployees
      }
    }
  }
  ${WorkplaceGroupEmployees}
`

export default function employees(variables: {
  workplaceGroupId: string
  first?: number
  query?: string
  after?: string
}): Promise<IWorkplaceGroupEmployeesConnectionWithTotal> {
  const { workplaceGroupId, first = 5, query = '', after = '' } = variables

  return client.gql
    .query({
      query: workplaceGroupEmployeesQuery,
      variables: {
        id: workplaceGroupId,
        first,
        where: {
          OR: [{ name_contains: query }, { email_contains: query }],
        },
        after,
      },
    })
    .then(({ data: { node } }: Payload) => node)
}
